/*
 * Mobile sticky Add to Cart bar - price, spec line and saving.
 *
 * WHAT IT ADDS
 * The bar showed only a wishlist heart and an Add to cart button, leaving
 * roughly 170px of empty space. It now reads:
 *
 *     [heart]  $1,955.00  $2,793.00     [ ADD TO CART ]
 *              1.5 CARAT - F - VS1
 *              30% OFF - ENDS SOON
 *
 * Mobile only. Above 767px the bar is untouched: the theme already shows the
 * image, title and price there.
 *
 * WHERE THE NUMBERS COME FROM, AND WHY IT MATTERS
 * NOT from the sticky bar's own price elements. Measured on the live theme:
 * when the shopper changes a variant on the product form, the sticky bar's
 * `.money-compare-price` updates but its `.money-subtotal` and its hidden
 * `input[name="id"]` DO NOT. Selecting "1.5 Carat" left the bar holding the
 * 1-Carat variant id and the 1-Carat price while the page showed 1.5 Carat.
 *
 * So everything here is derived from the MAIN product form's selected variant
 * id, looked up in the variant JSON the theme already prints into the page.
 * Prices come from that JSON in cents and are formatted with Intl, so the
 * figure on the bar always matches the variant the shopper actually chose.
 *
 * IT ALSO REPAIRS THAT DESYNC
 * `syncStickyVariant()` copies the main form's variant id into the sticky
 * form's hidden input. Without it the sticky Add to cart button submits a
 * stale variant - the shopper picks 1.5 Carat and the cart receives 1 Carat.
 * That is a pre-existing theme bug, not one introduced here, but this feature
 * would otherwise display a price the button disagrees with.
 *
 * The sync runs only when the MAIN form changes. A selection made inside the
 * sticky bar's own panel is therefore never clobbered.
 */

(function () {
  'use strict';

  var MOBILE_MAX = 767;

  /* Shown after the discount percentage. Set to '' to drop it. The percentage
     itself is computed from real compare-at pricing; this suffix is a
     marketing line and nothing verifies that the offer actually ends. */
  /* Civia (21 Sep 2026): cleared - see the note in civia-sale-banner.js. */
  var DEAL_SUFFIX = '';

  /* Middle dot, built from its code point so this file stays pure ASCII -
     a literal dot survives neither the JSON transport nor the ASCII gate. */
  var SEP = ' ' + String.fromCharCode(183) + ' ';

  var STYLE_ID = 'civia-satc-style';

  var CSS =
    '@media (max-width:' + MOBILE_MAX + 'px){' +
    '.productView-stickyCart.style-1 .sticky-right{align-items:center;gap:10px}' +
    '.productView-stickyCart.style-1 .sticky-right .sticky-wishlist{order:1;flex:0 0 auto}' +
    '.productView-stickyCart.style-1 .sticky-right .civia-satc{order:2;flex:1 1 auto;min-width:0;' +
    'display:flex;flex-direction:column;justify-content:center;gap:1px;line-height:1.2;overflow:hidden}' +
    '.productView-stickyCart.style-1 .sticky-right .sticky-actions{order:3;flex:0 0 auto;flex-grow:0}' +
    '}' +
    '@media (min-width:' + (MOBILE_MAX + 1) + 'px){.civia-satc{display:none}}' +
    '.civia-satc__row{display:flex;align-items:baseline;gap:6px;white-space:nowrap}' +
    '.civia-satc__price{font-size:15px;font-weight:600;color:#232323}' +
    '.civia-satc__was{font-size:12px;color:#8a8a8a;text-decoration:line-through}' +
    '.civia-satc__spec{font-size:10px;letter-spacing:.04em;text-transform:uppercase;color:#5a5a5a;' +
    'overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.civia-satc__deal{font-size:10px;letter-spacing:.04em;text-transform:uppercase;color:#b3261e;' +
    'font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.civia-satc__deal[hidden],.civia-satc__spec[hidden],.civia-satc__was[hidden]{display:none}';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function money(cents) {
    var currency = 'USD';

    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        currency = window.Shopify.currency.active;
      }
    } catch (e) {}

    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* The theme prints the full variant list into the sticky bar as JSON. Pick
     the array that actually carries prices - there are several such scripts
     and only one is the variant list. */
  function variantList(bar) {
    var scripts = bar.querySelectorAll('script[type="application/json"]');

    for (var i = 0; i < scripts.length; i++) {
      try {
        var parsed = JSON.parse(scripts[i].textContent);
        if (Array.isArray(parsed) && parsed.length && parsed[0] && typeof parsed[0].price === 'number') {
          return parsed;
        }
      } catch (e) {}
    }

    return null;
  }

  function idInputs() {
    var all = [].slice.call(document.querySelectorAll('form[action*="/cart/add"] input[name="id"]'));
    var main = null;
    var sticky = null;

    all.forEach(function (input) {
      if (input.closest('sticky-add-to-cart')) {
        if (!sticky) sticky = input;
      } else if (!main) {
        main = input;
      }
    });

    return { main: main, sticky: sticky };
  }

  function build(bar) {
    var right = bar.querySelector('.sticky-right');
    var actions = bar.querySelector('.sticky-actions');
    if (!right || !actions) return null;

    var block = document.createElement('div');
    block.className = 'civia-satc';
    block.innerHTML =
      '<span class="civia-satc__row">' +
      '<span class="civia-satc__price" data-satc-price></span>' +
      '<s class="civia-satc__was" data-satc-was hidden></s>' +
      '</span>' +
      '<span class="civia-satc__spec" data-satc-spec hidden></span>' +
      '<span class="civia-satc__deal" data-satc-deal hidden></span>';

    right.insertBefore(block, actions);
    return block;
  }

  function start() {
    var bar = document.querySelector('sticky-add-to-cart');
    if (!bar) return;

    var variants = variantList(bar);
    if (!variants) return;

    var inputs = idInputs();
    if (!inputs.main) return;

    injectStyle();

    var block = build(bar);
    if (!block) return;

    var priceEl = block.querySelector('[data-satc-price]');
    var wasEl = block.querySelector('[data-satc-was]');
    var specEl = block.querySelector('[data-satc-spec]');
    var dealEl = block.querySelector('[data-satc-deal]');

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    /* See the header: the theme leaves the sticky form holding a stale variant,
       so the button would add something other than what is on screen. */
    function syncStickyVariant(id) {
      if (inputs.sticky && inputs.sticky.value !== String(id)) {
        inputs.sticky.value = String(id);
      }
    }

    function update() {
      var id = inputs.main.value;
      var variant = findVariant(id);
      if (!variant) return;

      syncStickyVariant(id);

      priceEl.textContent = money(variant.price);

      var compare = variant.compare_at_price;
      var discounted = typeof compare === 'number' && compare > variant.price;

      wasEl.hidden = !discounted;
      if (discounted) wasEl.textContent = money(compare);

      var options = (variant.options || []).filter(Boolean);
      specEl.hidden = !options.length;
      if (options.length) specEl.textContent = options.join(SEP);

      dealEl.hidden = !discounted;
      if (discounted) {
        var percent = Math.round(((compare - variant.price) / compare) * 100);
        var text = percent + '% OFF';
        if (DEAL_SUFFIX) text += SEP + DEAL_SUFFIX;
        dealEl.textContent = text;
      }
    }

    update();

    /* The main form's id is written programmatically, which fires no event, so
       watch the attribute as well as listening for the interactions that cause
       it to change. */
    if (window.MutationObserver) {
      new window.MutationObserver(update).observe(inputs.main, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    document.addEventListener('change', function () { window.setTimeout(update, 60); }, false);
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.product-form__input, .product-form__swatch, variant-radios, variant-selects')) {
        window.setTimeout(update, 200);
      }
    }, false);

    /* Backstop: the property can be set without touching the attribute, which
       no observer sees. A cheap equality check a few times a second costs
       nothing and keeps the figure honest. */
    var lastSeen = inputs.main.value;
    window.setInterval(function () {
      if (inputs.main.value !== lastSeen) {
        lastSeen = inputs.main.value;
        update();
      }
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
